import { baseGlobals } from '@root/typescript/baseGlobals'

import log from '../Logger/log'

import testMimeType from './utils/testMimeType'
import type { TSoundTestResult } from './definitions'

/** Hangtámogatás tesztelése. */
export default async function soundSupportTester (): Promise<TSoundTestResult> {
  /**
   * Ezt jó ha látjuk fejlesztéskor, mert a debug panelben csak a típus van, a konkrét értékek nincsenek.
   * @param result - A támogatott formátum, vagy false.
   */
  function showResult (result: TSoundTestResult): void {
    if (!baseGlobals.isTest) {
      log('[SoundSystem]',
        result === false
          ? 'nincs hangtámogatás'
          : `${ result } hangtámogatás`
      )
    }
  }

  // Mindenféleképp futtassunk hang-tesztelést, mert nem megbízható
  // még cordova vagy electron alatt sem, hogy van-e hangtámogatás!

  const canPlayMp3 = await testMimeType('audio/mpeg')

  if (canPlayMp3) {
    showResult('mp3')

    return 'mp3'
  }

  // Csak akkor teszteljünk ogg-ra, ha az mp3 nem jó
  const canPlayOgg = await testMimeType('audio/ogg')

  if (canPlayOgg) {
    showResult('ogg')

    return 'ogg'
  }

  showResult(false)

  return false
}
